export var DeltaDirection;
(function (DeltaDirection) {
    DeltaDirection["Up"] = "up";
    DeltaDirection["Down"] = "down";
})(DeltaDirection || (DeltaDirection = {}));
//# sourceMappingURL=delta-direction.enum.js.map